export default {
  bmiCalculator: {
    actions: {
      calculateBMI: 'Calculate BMI',
      continue: 'Continue',
    },
    breadcrumbLink: 'Back',
    coveredTreatments: {
      CON_PC_B_VERK: 'breast reduction',
      CON_PC_G_BOL: 'upper eyelid correction',
      CON_PC_L_BUIKW: 'abdominoplasty',
    },
    header: 'We need more information',
    insuranceNotice:
      'Having a {{treatment}} performed on the basis of a medical indication? First, make an appointment with your family doctor to obtain a referral.',
    subheader:
      'In order book an appointment, we need to calculate your body mass index. Please specifying the following:',
  },
  bmiHigh: {
    actions: {
      callUs: 'Call us',
    },
    availableHours: {
      friday: 'Friday 8:00–17:00',
      mondayToThursday: 'Monday–Thursday 8:00–18:00',
      title: 'Available hours',
    },
    breadcrumbLink: 'Back',
    contactInfo: 'Please call our Information Centre at',
    header: 'We cannot schedule your appointment at this moment.',
    partnerInfo:
      'Through our partner, you can get support to work toward a healthy and realistic BMI. Would you like us to look together at what is possible for you? Or would you prefer a direct referral?',
    specialistInfo: 'We are happy to think along with you.',
    thresholdInfo:
      'Because your BMI is above {{bmiThreshold}}, we cannot plan a first consultation for you right now. Of course, we still want to help you.',
    yourBmi: 'Your BMI is ',
  },
  confirmBooking: {
    actions: {
      changeAppointment: 'Change appointment',
      confirmBooking: 'Continue',
    },
    breadcrumbLink: 'Select date and time',
    caption:
      'Please note: A consultation costs €30 (skin) or €50 (injectables and plastic surgery). These costs will be deducted from the final price of your treatment if you undergo it within a year.',
    header: 'Confirm details',
    selectDifferentTimeslot: 'Select a different timeslot',
  },
  errorScreen: {
    messages: {
      canNotAcceptPatientsUnder18:
        'Velthuis Clinics does not accept patients under the age of 18 for most treatments. Please contact us at 088-7785201 if you have any questions.',
    },
  },
  healthWarning: {
    acknowledgementLabel:
      "I understand that my health condition may influence the doctor's treatment advice.",
    actions: {
      continue: 'Continue',
    },
    breadcrumbLink: 'Back',
    conditions: {
      epilepsy: 'epilepsy',
      heartProblems: 'heart problems',
      lungProblems: 'lung problems',
      neurologicalIssues: 'neurological issues (brain)',
      smoking: 'do you smoke?',
    },
    description:
      'You are also welcome for a consultation. Our doctor will carefully evaluate what is the most suitable and safe treatment route for you during the consultation. Based on your health situation, an adjusted treatment plan may be advised.',
    header: 'Have you experienced any of the following in the past year:',
    subheader: 'Health information',
  },
  patientDetails: {
    actions: {
      continue: 'Continue',
    },
    description:
      'Please provide the following details to confirm your booking.',
    header: 'Fill in your details',
  },
  proposedAppointment: {
    actions: {
      confirmAppointment: 'Continue',
      selectTimeSlot: 'Select a different time slot',
    },
    description:
      'If the following proposed appointment doesn’t work for you, select a different time slot.',
    error: 'An error occurred while fetching the appointment slots.',
    header: 'Proposed appointment',
  },
  selectAppointment: {
    actions: {
      continue: 'Continue',
    },
    appointmentType: 'Appointment type',
    breadcrumbLink: 'Select category',
    header: 'What appointment would you like to make?',
  },
  selectCategory: {
    actions: {
      continue: 'Continue',
    },
    canNotAcceptPatientsUnder18:
      'Velthuis Clinics does not accept patients under the age of 18 for most treatments. Please contact us at 088-7785201 if you have any questions.',
    fillDate: 'Please fill in your date of birth',
    header: 'Specify category',
    learnMoreAboutDateOfBirth:
      'Read <0>here</0> why we ask for your date of birth',
    parentalConsentCheckbox: 'I confirm that I have obtained parental consent',
    subheader:
      'Which treatment would you like to book your follow up appointment for?',
  },
  selectClinic: {
    actions: {
      selectTimeSlot: 'Select time slot',
    },
    breadcrumbLink: 'Back',
    firstAvailability: 'First available: {{date}}',
    header: 'Select Clinic',
    selectDoctor: 'Select doctor',
    sortLabel: 'Sort by',
    sortOptions: {
      alphabetical: 'Alphabetical',
      availability: 'By availability',
    },
    subheader: 'Search clinics',
  },
  selectDateTime: {
    actions: {
      reviewBooking: 'Review booking',
      showAllClinicianSlots: 'Show all clinician slots',
    },
    breadcrumbLink: 'Select doctor',
    description:
      'Slot availability is updated in real time and will be confirmed after selection.',
    dropdownDoctors: {
      all: 'Show All',
      label: 'Select a doctor',
    },
    header: 'Select date and time',
    noSlots: 'No available slots for the selected location',
  },
  selectDoctor: {
    actions: {
      continue: 'Continue',
      selectAnotherLocation: 'Select another location',
      skipThisStep: 'Skip this step',
    },
    breadcrumbLink: 'Select clinic',
    header: 'Select clinician',
    noDoctorsFound:
      'No available healthcare providers for the selected location. Please try a different location.',
  },
}
